import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {ThemeSettings} from '../../../../shared/theme/interface';
import {
  VisImpFontSize,
  VisImpFontType,
  VisImpLetterSpacing,
  VisImpSwitchColor,
  VisImpSwitchImage,
  VisImpStatus,
} from '../../../../shared/models/visuallyImpairedSettings';

export interface ThemeState {
  settings: ThemeSettings;
}

const initialState: ThemeState = {
  settings: {
    fontSize: VisImpFontSize.Small,
    fontStyle: VisImpFontType.SansSerif,
    letterSpacing: VisImpLetterSpacing.Normal,
    switchColor: VisImpSwitchColor.Normal,
    switchImages: VisImpSwitchImage.True,
    visuallyImpaired: VisImpStatus.Disabled,
  },
};

type ChangeThemeArgs = {
  field: keyof ThemeSettings;
  value: unknown;
};

export const themeSlice = createSlice<ThemeState, SliceCaseReducers<ThemeState>>({
  name: '@@eskso/runtime/theme',
  initialState,
  reducers: {
    changeThemeProperty: (state, action: PayloadAction<ChangeThemeArgs>) => {
      const {field, value} = action.payload;
      // @ts-ignore
      state.settings[field] = value;
    },
  },
});

export const theme = themeSlice.reducer;
